import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Toast from '../commons/helpers/toast';
import * as types from '../../actions'; 

import { LBL_APP_NAME, LBL_LOGIN_AS, LBL_AFFILIATE, LBL_CLIENT, LBL_SELECT, LBL_SUBMIT } from '../../configs/labelConfigs'; 
import { ROUTE_REFRESH, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, RANDOM_COLORS, DISTANCE_UNIT, ROUTE_AFFILIATE_DASHBOARD, ROUTE_CLIENT_DASHBOARD } from '../../configs/staticConfigs';
import { MSG_AFFILIATE_REQUIRED } from '../../configs/msgConfigs';
import { loginAsUserAction } from '../../actions/commonActions';
import { loginClientAffiliateListAction } from '../../actions/authenticationActions';

import { getStorage,setStorage, getUserGroupData } from '../../utils/browserStorage';

class OMNUPointsComponent extends Component { 

    constructor(props) {
        super(props);
        this.state = {
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true, 
            loginAsGroup: 0, 
            loginAsType: '',
            loginAsProfileId: 0,
            loginAsProfileName: '',
            loginResponse: '',
            arrAffiliates: [],
            sel_affiliate: 0,
            formErrors_sel_affiliate: '',
        }   
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    } 

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    componentDidUpdate(prevProps) {   
        const { loginAsUserResponse, loginAsUserStatus, loginAsUserActivity, loginAsUserErrorData, loginAffiliateActivity, loginAffiliateResponse } = this.props;  

        if(loginAffiliateActivity !== prevProps.loginAffiliateActivity && loginAffiliateActivity===types.LOGIN_CLIENT_AFFILIATE_LIST_SUCCESS) {
            let arrAflt = []; 
            if(Array.isArray(loginAffiliateResponse.data.affiliates)) arrAflt = loginAffiliateResponse.data.affiliates; 
            this.setState({arrAffiliates:arrAflt}); 
        }

        if (loginAsUserActivity !== prevProps.loginAsUserActivity) {

            if(loginAsUserStatus===200) {
                // SET STORE VALUES AND REDIRECT TO AFFILIATE/CLIENT DASHBOARD 
                let loginResponse = loginAsUserResponse;
                let colors = RANDOM_COLORS; 
                let rand = Math.floor(Math.random()*colors.length);
                let currSymbol = (loginResponse.data.currency.currency_symbol) ? (loginResponse.data.currency.currency_symbol) : '\u00A3'; 
                let currObject = (loginResponse.data.currency) ? (loginResponse.data.currency) : {}; 
                let distance_unit = loginResponse.data.distance_unit && loginResponse.data.distance_unit.trim().length > 0 ? loginResponse.data.distance_unit : DISTANCE_UNIT;
                let resObject = { 
                    'refreshToken': loginResponse.data.tokens.refresh, 
                    'accessToken': loginResponse.data.tokens.access, 
                    'user_id': loginResponse.data.user_id,
                    'associate_id':loginResponse.data.associate_id,
                    'username': loginResponse.data.username,
                    'profilename':loginResponse.data.name,
                    'unid':loginResponse.data.unid,
                    'profile_id':loginResponse.data.profile_id,
                    'profile_img':loginResponse.data.image,
                    'user_group':this.state.loginAsGroup,
                    'user_permissions':loginResponse.data.permissions,
                    'profile_currency': currSymbol,
                    'profile_currency_object': currObject,
                    'fcm_notifi_token':'',
                    'fcm_notifi_token_sent':0,
                    'notification_count': loginResponse.data.notification_count,
                    'avatar_name': loginResponse.data.avatar_name,
                    'company_image':loginResponse.data.company_img,
                    'img_color': colors[rand],
                    'client_default_affiliate_id': 0,
                    'time_zone':loginResponse.data.time_zone,
                    'distance_unit': distance_unit,
                    'login_as_sa_user': 1,
                    'is_active': true,
                    'supervisor_name': loginResponse.data.supervisor_name,
                    'staff_name': loginResponse.data.staff_name,
                    'signature': loginResponse.data.signature,
                    'csv_template_path': loginResponse.data.csv_template_path,
                    'company_name': loginResponse.data.company_name,
                    'omnu_affiliate': loginResponse.data.omnu_affiliate
                }; 
                    
                if(this.state.loginAsGroup===LOGIN_AFFILIATE_GROUP) { 
                    setStorage('affiliate', JSON.stringify(resObject));
                    this.props.history.push(ROUTE_AFFILIATE_DASHBOARD); 
                }
                else if(this.state.loginAsGroup===LOGIN_CLIENT_GROUP){
                    setStorage('client', JSON.stringify(resObject));

                    let dataObj= {
                        clientId: loginResponse.data.profile_id,
                        userGroupToken: loginResponse.data.tokens.access,
                        unid:loginResponse.data.unid        
                    }
                    this.props.loginClientAffiliateListAction(dataObj);
                }
            }
            else {
                this.setState({loginResponse:JSON.stringify(loginAsUserErrorData)})
            }
        }
    }

    setAffiliate = () => {
        if(Number(this.state.sel_affiliate)===0) {
            this.setState({formErrors_sel_affiliate:MSG_AFFILIATE_REQUIRED}); 
            return false; 
        }
        else {
            let storageData = getUserGroupData('client');
            if(storageData!==null){
                let currSymbol = '\u00A3'; 
                let currObject = {}; 
                let arrAffiliates = this.state.arrAffiliates; 

                let afltObject = arrAffiliates.filter(item => Number(item.company_id)===Number(this.state.sel_affiliate)); 
                let distance_unit = DISTANCE_UNIT;  
                if(afltObject.length) {
                    currSymbol = afltObject[0].currency_symbol; 
                    currObject = {"currency_id": afltObject[0].currency_id,
                    "currency_name": afltObject[0].currency_name,
                    "currency_symbol": afltObject[0].currency_symbol}; 
                    distance_unit = afltObject[0].distance_unit && afltObject[0].distance_unit.trim().length > 0 ? afltObject[0].distance_unit : DISTANCE_UNIT; 
                }

                storageData.profile_currency = currSymbol; 
                storageData.profile_currency_object = currObject; 
                storageData.client_default_affiliate_id = this.state.sel_affiliate; 
                storageData.distance_unit = distance_unit; 

                setStorage('client', JSON.stringify(storageData));
                this.props.history.push(ROUTE_CLIENT_DASHBOARD); 
            }
        }
    }

    onHandleChange = (event) =>{
        event.preventDefault();

        const {name,value} = event.target;
        let formErrors_sel_affiliate     = '';

        switch(name){
            case 'sel_affiliate':
                formErrors_sel_affiliate = Number(value) <=0 ? MSG_AFFILIATE_REQUIRED : ""
                break;    
            default :
            break;
        }

        this.setState({sel_affiliate:value,formErrors_sel_affiliate});
       
    }

    componentDidMount() { 
        document.title = LBL_APP_NAME+" - "+LBL_LOGIN_AS;
        // const { loginAsData, loginAsDataStatus } = this.props;        
        let saLoginAsData = JSON.parse(getStorage('saLoginAsData'));
        if(Number(saLoginAsData.loginAs)===Number(LOGIN_AFFILIATE_GROUP)) {
            this.setState({loginAsGroup:LOGIN_AFFILIATE_GROUP, loginAsType:LBL_AFFILIATE, loginAsProfileId: saLoginAsData.profileId, loginAsProfileName: saLoginAsData.profileName}); 
            let userData= {
                group:LOGIN_AFFILIATE_GROUP, 
                login_as: true,
                profile_id: saLoginAsData.profileId,
                user_id: saLoginAsData.saUserId
            }
            this.props.loginAsUserAction(userData);
            let dataObj = {}; 
            setStorage('saLoginAsData', JSON.stringify(dataObj));
        }
        else if(saLoginAsData.hasOwnProperty('loginAs') && Number(saLoginAsData.loginAs)===Number(LOGIN_CLIENT_GROUP)) {
            this.setState({loginAsGroup:LOGIN_CLIENT_GROUP, loginAsType:LBL_CLIENT, loginAsProfileId: saLoginAsData.profileId, loginAsProfileName: saLoginAsData.profileName}); 
            let userData= {
                group:LOGIN_CLIENT_GROUP, 
                login_as: true,
                profile_id: saLoginAsData.profileId,
                user_id: saLoginAsData.saUserId
            }
            this.props.loginAsUserAction(userData);
            let dataObj = {}; 
            setStorage('saLoginAsData', JSON.stringify(dataObj));
        } 
    }

    render(){
        const { toastMessage,toastFlag,toastSuccess,loginAsType, loginAsProfileName, arrAffiliates, loginAsGroup, sel_affiliate, formErrors_sel_affiliate } = this.state;    

        if(this.props.status===401 || this.props.status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        return(
            <div className="col-md-4">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <div className="box">
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}} >
                                <thead>
                                    <tr>
                                        <th className="text-left" colSpan="2">{LBL_LOGIN_AS} {(loginAsType.length > 0 && loginAsProfileName.length > 0 ) ? loginAsType+' - '+loginAsProfileName : ''}</th>
                                    </tr>
                                </thead>
                                <tbody>                          
                                    <tr className="border-none">
                                        <td>
                                        {(arrAffiliates.length > 0) && (loginAsGroup===LOGIN_CLIENT_GROUP) && 
                                            <><div>
                                                <div className="form-group">
                                                    <label>{LBL_SELECT+' '+LBL_AFFILIATE}</label>
                                                    <div className="form-group select-input" style={{verticalAlign: "middle"}} >
                                                        <select onChange={this.onHandleChange} name="sel_affiliate" value={sel_affiliate || ''} className={formErrors_sel_affiliate.length >0 ? "paddingTopBottom10 input-error" : 'paddingTopBottom10'} >
                                                            {/* {(affiliatesCount===0 || affiliatesCount > 1) && <option value="">Select</option>} */}
                                                            <option value="0">{LBL_SELECT}</option>
                                                            {arrAffiliates.map((item) => <option key={item.company_id} value={item.company_id}>{item.company_name}</option>)}  
                                                        </select> 
                                                        {formErrors_sel_affiliate.length >0 && (
                                                            <div className="text-red left-align text-12">{formErrors_sel_affiliate}</div> 
                                                        )}  
                                                    </div>    
                                                </div>
                                            </div> 
                                            <div>&nbsp;</div>
                                            <div> 
                                                <div className="form-group">
                                                <button onClick={this.setAffiliate} className="btn btn-primary float-right">{LBL_SUBMIT}</button>
                                                </div>
                                            </div></>
                                        } 
                                        </td>
                                        <td className="text-right">
                                            {/* <button type="submit" className="btn btn-primary">Save</button> */}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
        
    }
    
} 

const mapStateToProps = (state) => {
    return {
        loginAffiliateActivity: state.login.loginAffiliateActivity,
        loginAffiliateResponse: state.login.response,
        // loginAsData: state.commons.loginAsData, 
        loginAsDataStatus: state.commons.loginAsDataStatus,
        loginAsUserResponse: state.commons.loginAsUserResponse,
        loginAsUserStatus: state.commons.loginAsUserStatus,  
        loginAsUserErrorData: state.commons.loginAsUserErrorData,  
        loginAsUserActivity: state.commons.loginAsUserActivity,  
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loginAsUserAction:loginAsUserAction,
        loginClientAffiliateListAction:loginClientAffiliateListAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(OMNUPointsComponent);